export const CODE_PARAM = "code";
export const V2_CLIENT_CODE_KEY = 'p4WjNp_vNJYq6FS5GFAaAu0yJD2bQvFI1mXyYxwWrIsXAzFuuFVDcA==';

//get client https://vizomenuapi.azurewebsites.net/api/{clientID}?code=ile2pd0d5dQTJmqCWmW2T-9A2C4H0VuAtYu88uulZTipAzFuRTWNog==
export const BASE_URL = 'https://vizomenu-api-v2.azurewebsites.net/api/';

//get menu https://vizomenuapi.azurewebsites.net/api/locations/{{locId}}/menus
export const TOP_MENU_API_BASE = `${BASE_URL}locations/`;

//get sub menu {{base_url}}/api/menus/{{menuId}}/submenus
export const SUBMENU_API_BASE = `${BASE_URL}`;

//get items https://vizomenuapi.azurewebsites.net/api/subMenu/{inSubMenuID}?code=Si4XAoJVcafk_5Zi74dIyl0aO36sX5UN4bYu8DiSkuQhAzFuZJ8iGg==
export const ITEM_LIST_BASE_URL = `${BASE_URL}submenus/`;

//https://vizomenuapi.azurewebsites.net/api/item/{inItemID}?code=60pXseKQ7tY8MA7L9fe1QoS8HMah07gXrFrtME5cYwjXAzFuzPf11Q==
export const SINGLE_ITEMS_API_BASE = `${BASE_URL}item/`;

//https://vizomenuapi.azurewebsites.net/api/contact?code=yFrUgwgW8HDlcETrjFB_x6DOhfmlaGXzve4xZlQn5ChnAzFuF3vZ1g==
export const CONTACT_US_API_BASE = `${BASE_URL}contactus`;

//https://vizomenuapi.azurewebsites.net/api/contact/request
export const CONTACT_REQUEST_API_BASE = `${BASE_URL}locations/`;

//https://vizomenuapi.azurewebsites.net/api/recommend/{locid}/{inItemID}?code=OGgaOxKIGEtDyhkbpIaO8s5n4OCcmK-8-g-a6PUxD1QJAzFucSJL_g==
export const RECOMMENDED_ITEMS_API_BASE = `${BASE_URL}recommend/`;

//https://vizomenuapi.azurewebsites.net/api/ads/{inLocid}?code=MHBcB7xTlmpRsfDoV0tnCwLNreZD2IesEcKnkGjawVy-AzFu4OR7gg==
export const GET_LOCATION_ADS_API_BASE = `${BASE_URL}ads/`;

//https://vizomenu-api-v2.azurewebsites.net/api/ads/viewed?code=p4WjNp_vNJYq6FS5GFAaAu0yJD2bQvFI1mXyYxwWrIsXAzFuuFVDcA==
export const TRACK_VIEWED_AD_API_BASE = `${BASE_URL}ads/viewed/`;

//https://vizomenuapi.azurewebsites.net/api/profiles/{locid}?code=-DWPGNNTix7c8CNOzUvogskMwpBByyamqy2MGeJeu5TWAzFuNs6N0w%3D%3D
export const SEARCH_CRITERIA_API_BASE = `${BASE_URL}profiles/`;

